import { render, staticRenderFns } from "./HistoryReceiptProduct.vue?vue&type=template&id=eafe132c&scoped=true&"
import script from "./HistoryReceiptProduct.vue?vue&type=script&lang=js&"
export * from "./HistoryReceiptProduct.vue?vue&type=script&lang=js&"
import style0 from "./HistoryReceiptProduct.vue?vue&type=style&index=0&id=eafe132c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafe132c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
